export default __webpack_public_path__ + "static/media/Natesa Jewellery.2aacc9ec.png";